import { gql, useMutation } from '@apollo/client';
import { getLanguageDefaults } from '@onevesthq/ov-translations';
import { Box } from '@ovComponents/1-primative/box/box';
import { TextField } from '@ovComponents/2-component/textField/textField';
import { TranslatableTextField } from '@ovComponents/2-component/translatableTextField/translatableTextField';
import { CreateNewModal } from '@ovComponents/3-pattern/createNewModal/createNewModal';
import { OrganizationSelect } from '@ovComponents/3-pattern/organizationSelect/organizationSelect';
import { UserContext } from '@providers/userContextProvider';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const CREATE_ORGANIZATION = gql`
  mutation createOrganization($input: CreateOrganizationInput!) {
    createOrganization(input: $input) {
      organization {
        id
      }
    }
  }
`;

export const NewOrganization = ({
  afterCreate,
}: {
  afterCreate: (newOrgId: string) => void;
}) => {
  const { t } = useTranslation(['orgSettings']);
  const { activeOrganization } = useContext(UserContext);
  const [organization, setOrganization] = useState({
    translatedName: getLanguageDefaults(),
    subdomain: '',
    parentId: '',
    useParentRoleProfiles: true,
    useParentStaticPageWidgetConfigurations: true,
    useParentCustomFields: true,
    useParentIntegrations: true,
  });

  const [createOrganization, { loading }] = useMutation(CREATE_ORGANIZATION, {
    variables: {
      input: organization,
    },
  });

  useEffect(() => {
    setOrganization({ ...organization, parentId: activeOrganization.id ?? '' });
  }, [activeOrganization]);

  const createOrg = async () => {
    const response = await createOrganization();
    afterCreate(response.data.createOrganization.organization.id);
  };

  return (
    <CreateNewModal
      loading={loading}
      title={t('newOrganizationModal.title')}
      onSubmit={createOrg}
      buttonVariant='tonal'
    >
      <Box display='flex' flexDirection='column' gap={2}>
        <TranslatableTextField
          label={t('organizationDetails.name')}
          fullWidth
          value={organization.translatedName}
          onChange={(value) =>
            setOrganization({
              ...organization,
              translatedName: value,
            })
          }
        />
        <TextField
          label={t('organizationDetails.subdomain')}
          fullWidth
          value={organization.subdomain}
          onChange={(event: any) =>
            setOrganization({ ...organization, subdomain: event.target.value })
          }
        />
        <OrganizationSelect
          value={organization.parentId}
          label={t('organizationDetails.parent')}
          onChange={(event: any) =>
            setOrganization({ ...organization, parentId: event as string })
          }
        />
      </Box>
    </CreateNewModal>
  );
};
